import { render, staticRenderFns } from "./OrderSearch.vue?vue&type=template&id=65511ad5&scoped=true"
import script from "./OrderSearch.vue?vue&type=script&lang=js"
export * from "./OrderSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65511ad5",
  null
  
)

export default component.exports